import { OCEAN_MARQUEE } from "../../data/oceanContent";

export default function OceanMarquee() {
  const items = [...OCEAN_MARQUEE, ...OCEAN_MARQUEE];
  return (
    <div className="relative border-y border-oreef/10 bg-oabyss/40 py-5 overflow-hidden" data-testid="ocean-marquee">
      <div className="flex marquee-track whitespace-nowrap">
        {items.map((t, i) => (
          <span key={i} className="flex items-center font-display font-semibold uppercase tracking-[0.08em] text-2xl sm:text-3xl text-oseaglass/85">
            <span className="px-8">{t}</span>
            <span className="text-ocoral">◆</span>
          </span>
        ))}
      </div>
    </div>
  );
}
